import React from "react";
import {
  Box,
  Flex,
  Heading,
  Tooltip,
  Icon,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { FaCircleInfo } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import { useGetProjectVideosQuery } from "services/api";
import Clip from "./Clip";

export default function LeftSidebar({ leftSidebarWidth, startLeftResize }) {
  const { projectId } = useParams();

  // Fetch actual clips from the API
  const { data: clipsData, isLoading, error } = useGetProjectVideosQuery(
    projectId
  );

  // Ensure minimum width of 100 pixels
  const sidebarWidth = Math.max(leftSidebarWidth, 100);

  return (
    <Flex
      bg="gray.50"
      borderRight="1px solid"
      borderRightColor="gray.200"
      flexDirection="column"
      height="100%"
      minWidth="150px"
      overflow="visible"
      position="relative"
      width={`${sidebarWidth}px`}
    >
      <Box height="100%" overflowY="auto" p={4}>
        <Flex alignItems="center" mb={4}>
          <Heading as="h2" fontSize="sm" mr={1}>
            Culled Clips
          </Heading>
          <Tooltip
            hasArrow
            label="Clips auto-culled by MagicSeven. You can export them or generate scenes via prompt."
            placement="top"
            textAlign="center"
          >
            <Box display="inline-block" ml={0.5}>
              <Icon as={FaCircleInfo} boxSize={3} color="gray.500" />
            </Box>
          </Tooltip>
          {typeof clipsData?.count === "number" && clipsData.count > 0 && (
            <Text color="gray.500" fontSize="xs" ml="auto">
              {clipsData.count} clips
            </Text>
          )}
        </Flex>

        {isLoading ? (
          <Flex justify="center" py={4}>
            <Spinner size="md" />
          </Flex>
        ) : error ? (
          <Box color="red.500" fontSize="sm" textAlign="center">
            Error loading clips
          </Box>
        ) : clipsData?.videos ? (
          clipsData.videos.map((clip) => (
            <Clip clip={clip} key={clip.filename} />
          ))
        ) : (
          <Box color="gray.500" fontSize="sm" textAlign="center">
            No clips found
          </Box>
        )}
      </Box>

      {/* Left resize handle */}
      <Box
        _hover={{ bg: "blue.100", opacity: 0.6 }}
        aria-label="Resize sidebar"
        bg="transparent"
        cursor="ew-resize"
        height="100%"
        onMouseDown={startLeftResize}
        position="absolute"
        right={0}
        top={0}
        width="8px"
        zIndex={3}
      />
    </Flex>
  );
}
